import { useQuery } from "react-query";
import API from "../shared-utils/api";
const fetchApplicableOffers = async (params) => {
    const { data } = await API.get("/api/v1/rbzo/coupon/customer/applicable-offers", {
        params: {
            event_id: params.eventId,
            reservation_time: params.reservationTime,
        },
    });
    const arr = data === null || data === void 0 ? void 0 : data.data;
    return Array.isArray(arr) ? arr : [];
};
export const useApplicableOffers = (params) => {
    var _a, _b;
    const enabled = !!params.eventId && !!params.reservationTime;
    return useQuery([
        "applicable-offers",
        (_a = params.eventId) !== null && _a !== void 0 ? _a : "",
        (_b = params.reservationTime) !== null && _b !== void 0 ? _b : "",
    ], () => fetchApplicableOffers({
        eventId: params.eventId,
        reservationTime: params.reservationTime,
    }), {
        enabled,
    });
};
